import { render } from "./Flip.vue?vue&type=template&id=4fe7a122"
import script from "./Flip.vue?vue&type=script&lang=js"
export * from "./Flip.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__